@import 'core';

/**
 * @prop --ads-breadcrumbs-color: Default text color
 * @prop --ads-breadcrumbs-link-color: Default link text color
 * @prop --ads-breadcrumbs-link-color-hover: Hovered link text color
 * @prop --ads-breadcrumbs-link-color-visited: Visited link text color
 * @prop --ads-breadcrumbs-text-decoration: Text decoration
 * @prop --ads-breadcrumbs-text-decoration-hover: Text decoration hover
 */

$properties: (
  ads-breadcrumbs-font-size: 12px,
);

::slotted(*) {
  display: inline-block !important;
}

:host {
  @each $key, $value in $properties {
    --#{$key}: #{$value};
  }
  font-family: var(--ads-font-family);
  font-size: var(--ads-breadcrumbs-font-size);
}

:host([theme='default']) {
  @include ads-vars-component-breadcrumbs-default;
}

:host([theme='dark']) {
  @include ads-vars-component-breadcrumbs-dark;
}

:host([theme='light']) {
  @include ads-vars-component-breadcrumbs-light;
}

.c-breadcrumbs {
  color: var(--ads-breadcrumbs-color, $ads-breadcrumbs-color);
  display: block !important;
  font-family: var(--ads-font-family);
  font-size: var(--ads-breadcrumbs-font-size);
}
